import Seo from "@/components/Seo";
import { TestimonialsSection } from "@/components/Testimonials";
import { SocialLinks } from "@/components/SocialLinks";
import { SiteHeader } from "@/components/SiteHeader";

export default function Testimonials() {
  return (
    <div className="min-h-screen bg-[#F9F6F1]" data-testid="testimonials-page">
      <Seo title="Testimonials · The Next Move by Rhellex" description="Feedback, testimonials and recommendations from clients of The Next Move by Rhellex." />

      <SiteHeader />

      <main className="max-w-6xl mx-auto px-6 py-16 lg:py-24">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D94833]">Feedback &amp; recommendations</p>
        <h1 className="font-head text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight font-black mt-4 text-[#041C3E]">
          Client stories and results.
        </h1>
        <p className="text-base md:text-lg text-[#3A4A63] mt-5 max-w-2xl leading-relaxed">
          Real feedback from students, professionals and partners who worked with Rhea to find clarity, reposition themselves and take the next step with confidence.
        </p>

        <div className="mt-14">
          <TestimonialsSection heading="Every story starts with a decision." />
        </div>

        <div className="mt-16 border-t border-[#E5E7EB] pt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <p className="text-sm text-[#3A4A63] max-w-md">
            Worked with Rhea and want to share your experience? We would love to hear from you.
          </p>
          <a href="mailto:thenextmovebyrhellex@gmail.com" data-testid="testimonials-share"
            className="bg-[#041C3E] text-white px-8 py-4 font-semibold tracking-wide hover:bg-[#D94833] transition-colors">
            Share your feedback
          </a>
        </div>

        <div className="mt-12"><SocialLinks /></div>
      </main>
    </div>
  );
}
